import React, { useState, useEffect, useMemo } from 'react'
import { getSourceTypeId } from 'utilities'
import { useDispatch } from 'react-redux'
import { SelectBox } from '@tecuity/granite-ui/SelectBox'
import SelectableCheckboxList, {
  CheckboxList,
} from '../SettingsViews/SettingsComponents/SelectableCheckboxList'
import * as api from '../../../requests'
import '../SettingsViews/SettingsListView.scss'
import { setErrorToast, setSuccessToast } from '../../../actions'
import { useRequestData } from '../../../Utilities/hooks'
import { Spinner } from '../../Loaders/Loaders'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
// import { TextInput } from '@tecuity/granite-ui/TextInput'
import Revert from '@tecuity/sos-icons/react/revert'
import RightArrow from '@tecuity/sos-icons/react/right-arrow'
import { Checkbox } from '@tecuity/granite-ui/Checkbox'

const UCCFilingToRecordTypeXref = () => {
  const dispatch = useDispatch()
  const imagePageTypes = useRequestData(api.GET_ALL_IMAGE_PAGE_TYPES, [], [])
  const recordAccessUserRoles = useRequestData(
    (cb, errCb) => {
      api.GET_RECORD_ACCESS_USER_ROLES_BY_SOURCE_TYPE(getSourceTypeId('ucc'), cb, errCb)
    },
    [],
    []
  )
  const formData = useRequestData(
    (cb, errCb) => api.GET_ALL_FORMS_BY_CATEGORY('UCC', cb, errCb),
    [],
    []
  )
  // const uccLapseTypes = useRequestData(
  //   (cb, errCb) => api.GET_ACTIVE_BASIC_LOOKUP_TYPES('UCC', 'LapseType', cb, errCb),
  //   [],
  //   []
  // )
  const appReports = useRequestData(api.GET_APP_REPORTS, [], [])
  const [recordTypeOptions, setRecordTypeOptions] = useState([])
  const [filingTypeList, setFilingTypeList] = useState([])
  const [statusTypeList, setStatusTypeList] = useState([])
  const [recordType, setRecordType] = useState(0)
  const [activeFilingId, setActiveFilingId] = useState(0)
  const [originalIds, setOriginalIds] = useState([])
  const [checkedFilingTypeIds, setCheckedFilingTypeIds] = useState([])
  const [xRef, setXRef] = useState({ ...defaultDto })
  const [xRefMap] = useState({})
  const [loadingXref, setLoadingXref] = useState(false)
  const [isDirty, setIsDirty] = useState(false)

  useEffect(() => {
    getLookupTypeOptions()
  }, [])

  const getLookupTypeOptions = () => {
    api.GET_ACTIVE_BASIC_LOOKUP_TYPES(
      'UCC',
      'RecordType',
      (res) => {
        setRecordTypeOptions([
          ...res.map((t) => ({
            value: t.Id,
            label: t.Name,
          })),
        ])
        if (!recordType && res.length > 0) setRecordType(res[0].Id)
      },
      (err) => {
        setRecordTypeOptions([])
        console.error(err.message)
      }
    )
    api.GET_ACTIVE_BASIC_LOOKUP_TYPES(
      'UCC',
      'FilingType',
      (res) => {
        setFilingTypeList(res)
      },
      (err) => {
        setFilingTypeList([])
        console.error(err.message)
      }
    )

    api.GET_ACTIVE_BASIC_LOOKUP_TYPES(
      'UCC',
      'StatusType',
      (res) => {
        setStatusTypeList(res)
      },
      (err) => {
        setStatusTypeList([])
        console.error(err.message)
      }
    )
  }

  const getUccFilingTypeIdsByRecordType = (controller) => {
    if (recordType) {
      api.GET_SETTINGS_UCC_FILING_TYPE_IDS_BY_RECORD_TYPE(
        { signal: controller.signal },
        recordType,
        (res) => {
          if (res) {
            setCheckedFilingTypeIds(res)
            setOriginalIds(res)
          }
        },
        (err) => {
          console.error(err)
          dispatch(setErrorToast('Failed to load selected Filing Type Ids'))
        }
      )
    }
  }

  useEffect(() => {
    const controller = new AbortController()
    getUccFilingTypeIdsByRecordType(controller)
    return () => {
      controller.abort()
    }
  }, [recordType])

  const getXrefByRecordTypeFilingType = (controller) => {
    if (recordType && activeFilingId) {
      setLoadingXref(true)
      api.GET_SETTINGS_UCC_FILING_TO_RECORD_XREF(
        { signal: controller.signal },
        recordType,
        activeFilingId,
        (res) => {
          if (isDirty && Object.keys(xRefMap).includes(activeFilingId.toString())) {
            setXRef({ ...xRefMap[activeFilingId] })
          } else if (res) {
            setXRef({
              ...res,
              ReportIds: res.ReportConfigJson ? JSON.parse(res.ReportConfigJson) : [],
              RequiredUCCStatusTypeIds: res.RequiredUCCStatusTypeIdsJson
                ? JSON.parse(res.RequiredUCCStatusTypeIdsJson)
                : [],
            })
          } else {
            setXRef({
              ...defaultDto,
              UCCRecordTypeId: recordType,
              UCCFilingTypeId: activeFilingId,
            })
          }
          setLoadingXref(false)
        },
        (err) => {
          console.error(err)
          if (JSON.parse(err).status !== 404) dispatch(setErrorToast('Failed to load Xref'))
          setLoadingXref(false)
        }
      )
    }
  }

  useEffect(() => {
    const controller = new AbortController()
    getXrefByRecordTypeFilingType(controller)
    return () => {
      controller.abort()
    }
  }, [recordType, activeFilingId])

  const clickRevert = () => {
    Object.keys(xRefMap).forEach((key) => {
      delete xRefMap[key]
    })
    setIsDirty(false)
    getUccFilingTypeIdsByRecordType(new AbortController())
    getXrefByRecordTypeFilingType(new AbortController())
    getLookupTypeOptions()
  }

  const clickSave = () => {
    const promiseArray = []
    delete xRefMap['0']
    const changedFilingTypeIds = Object.keys(xRefMap)

    // console.log(changedFilingTypeIds)
    changedFilingTypeIds.forEach((filingTypeId) => {
      if (originalIds.includes(+filingTypeId)) {
        if (checkedFilingTypeIds.includes(+filingTypeId)) {
          // update the existing
          promiseArray.push(
            new Promise((resolve, reject) => {
              api.SAVE_SETTINGS_UCC_FILING_TYPE_RECORD_TYPE_XREF(
                'PUT',
                xRefMap[filingTypeId],
                resolve,
                reject
              )
            })
          )
        } else {
          // delete the existing
          promiseArray.push(
            new Promise((resolve, reject) => {
              api.DELETE_SETTINGS_UCC_FILING_TYPE_RECORD_TYPE_XREF(
                recordType,
                filingTypeId,
                resolve,
                reject
              )
            })
          )
        }
      } else if (checkedFilingTypeIds.includes(+filingTypeId)) {
        // add new xref
        promiseArray.push(
          new Promise((resolve, reject) => {
            api.SAVE_SETTINGS_UCC_FILING_TYPE_RECORD_TYPE_XREF(
              'POST',
              xRefMap[filingTypeId],
              resolve,
              reject
            )
          })
        )
      } else {
        // nothing changed
        console.warn('UCC Xref data out of sync. This should NOT happen.')
      }
    })

    if (promiseArray.length > 0) {
      setLoadingXref(true)
      Promise.all(promiseArray)
        .then((xrefs) => {
          // console.log(xrefs)
          dispatch(setSuccessToast('Saved Setting(s) successfully.'))
          clickRevert()
          setLoadingXref(false)
        })
        .catch((err) => {
          if (err.DisplayToUser === true && (err.Message || '') !== '') {
            dispatch(setErrorToast(err.Message))
          } else {
            dispatch(setErrorToast('Failed to save setting.'))
          }
          setLoadingXref(false)
        })
    }
  }

  const disableXrefSettings = useMemo(() => {
    if (loadingXref) return true
    return !checkedFilingTypeIds.includes(activeFilingId)
  }, [activeFilingId, checkedFilingTypeIds, loadingXref])

  const changeXrefValue = (property, value) => {
    setXRef({ ...xRef, [property]: value })
    setIsDirty(true)
  }

  useEffect(() => {
    xRefMap[xRef.UCCFilingTypeId] = { ...xRef }
  }, [xRef])

  return (
    <div className="settings-list-view">
      <h2>UCC Filing to Record Type</h2>
      <div className="settings-content">
        <div className="settings-left-column">
          <div className="custom-correspondence-options">
            <SelectBox
              label="Record Type"
              noPlaceholder
              value={recordType || ''}
              onChange={(val) => {
                setRecordType(+val)
                setActiveFilingId(0)
              }}
              options={recordTypeOptions}
              disabled={isDirty ? true : undefined}
              description={isDirty ? 'Save or Revert changes to modify.' : undefined}
            />
          </div>
          <SelectableCheckboxList
            label={`Filing Types`}
            items={filingTypeList.map((type) => {
              return {
                id: type.Id,
                label: type.Name,
              }
            })}
            activeId={activeFilingId}
            setActiveId={setActiveFilingId}
            checked={checkedFilingTypeIds}
            setChecked={(ids) => {
              setCheckedFilingTypeIds(ids)
              setIsDirty(true)
            }}
          />
        </div>
        <div className="properties-list scrollable">
          {/* DETAILS */}
          <h3
            style={{
              textDecoration: 'underline',
              display: 'flex',
              alignSelf: 'center',
              fontWeight: 'bold',
            }}
          >
            Details
          </h3>
          <SelectBox
            label="Image Page Type"
            options={imagePageTypes
              .map((imagePageType) => {
                return {
                  label: imagePageType.Name,
                  value: imagePageType.Id,
                }
              })
              .sort((a, b) => {
                return a.label > b.label ? 1 : -1
              })}
            onChange={(value) => {
              changeXrefValue('ImagePageTypeId', +value)
            }}
            value={xRef.ImagePageTypeId || ''}
            disabled={disableXrefSettings}
          />

          <SelectBox
            label="Form Title"
            options={formData
              .filter((form) => {
                return form.IsActive
              })
              .map((form) => {
                return {
                  label: form.Title,
                  value: form.FormDefinitionId,
                }
              })
              .sort((a, b) => {
                return a.label > b.label ? 1 : -1
              })}
            onChange={(value) => {
              changeXrefValue('FormDefinitionId', +value)
            }}
            value={xRef.FormDefinitionId || ''}
            disabled={disableXrefSettings}
          />

          {/* REQUIREMENTS FOR FILING */}
          <h3
            style={{
              textDecoration: 'underline',
              display: 'flex',
              alignSelf: 'center',
              fontWeight: 'bold',
            }}
          >
            Requirements to File
          </h3>
          <CheckboxList
            label="Record Access Roles Permitted to File (Leave blank to allow open filing)"
            items={recordAccessUserRoles
              .filter((x) => x.CanFileAmendments)
              .map((role) => ({
                id: role.RecordAccessUserRoleId,
                label: role.Name,
              }))
              .sort((a, b) => (a.label > b.label ? 1 : -1))}
            checkedIds={xRef.PermittedRecordAccessUserRoleIds || []}
            setChecked={(ids) => {
              changeXrefValue('PermittedRecordAccessUserRoleIds', ids)
            }}
          />

          <CheckboxList
            label={'Status to File'}
            items={statusTypeList
              .map((type) => ({ id: type.Id, label: type.Name }))
              .sort((a, b) => {
                return a.label > b.label ? 1 : -1
              })}
            checkedIds={xRef.RequiredUCCStatusTypeIds || []}
            setChecked={(ids) => {
              changeXrefValue('RequiredUCCStatusTypeIds', ids)
            }}
            disabled={disableXrefSettings}
          />

          {/* AFTER APPROVAL */}
          <h3
            style={{
              textDecoration: 'underline',
              display: 'flex',
              alignSelf: 'center',
              fontWeight: 'bold',
            }}
          >
            Results of Approved Filing
          </h3>

          <SelectBox
            label="Record Access Role Granted Post-Approval"
            options={recordAccessUserRoles
              .map((role) => {
                return {
                  label: role.Name,
                  value: role.RecordAccessUserRoleId,
                }
              })
              .sort((a, b) => {
                return a.value > b.value ? 1 : -1
              })}
            onChange={(value) => {
              changeXrefValue(
                'NewRecordAccessUserRoleId',
                value === '' ? null : +value
              )
            }}
            value={xRef.NewRecordAccessUserRoleId || ''}
            disabled={disableXrefSettings}
          />

          <SelectBox
            label="Lien Status After Filing"
            options={[...statusTypeList, { Name: 'No Change', Id: -1 }]
              .map((cd) => {
                return {
                  label: cd.Name,
                  value: cd.Id,
                }
              })
              .sort((a, b) => {
                return a.label === 'No Change' ? -1 : a.label > b.label ? 1 : -1
              })}
            onChange={(value) => {
              changeXrefValue('NewUCCStatusTypeId', +value)
            }}
            value={xRef.NewUCCStatusTypeId || -1}
            disabled={disableXrefSettings}
            noPlaceholder
          />

          {/* <SelectBox
            label="UCC Lapse Type"
            options={uccLapseTypes
              .map((form) => {
                return {
                  label: form.Name,
                  value: form.Id,
                }
              })
              .sort((a, b) => {
                return a.label > b.label ? 1 : -1
              })}
            onChange={(value) => {
              changeXrefValue('UCCLapseTypeId', +value)
            }}
            value={xRef.UCCLapseTypeId || ''}
            disabled={disableXrefSettings}
          /> */}

          {/* <TextInput
            label={`Initial Lapse Length`}
            value={xRef.InitialLapseLength || ''}
            onChange={(e) => {
              changeXrefValue('InitialLapseLength', e.target.value)
            }}
            disabled={disableXrefSettings || !xRef.UCCLapseTypeId || xRef.UCCLapseTypeId === 3} // No Lapse Date
            type="number"
          />

          <TextInput
            label={`Continuation Lapse Length`}
            value={xRef.ContinuationLapseLength || ''}
            onChange={(e) => {
              changeXrefValue('ContinuationLapseLength', e.target.value)
            }}
            disabled={disableXrefSettings || !xRef.UCCLapseTypeId || xRef.UCCLapseTypeId === 3} // No Lapse Date
            type="number"
          /> */}

          <Checkbox
            label="Include Original Image with Approval Stamp for Paper Filings"
            checked={xRef.IncludeImageForPaperFiling || false}
            onChange={(checked) => {
              changeXrefValue('IncludeImageForPaperFiling', checked)
            }}
            disabled={disableXrefSettings}
          />

          <CheckboxList
            label={'Generated Reports'}
            items={appReports
              .map((appReport) => ({ id: appReport.Id, label: appReport.Name }))
              .sort((a, b) => {
                return a.label > b.label ? 1 : -1
              })}
            checkedIds={xRef.ReportIds || []}
            setChecked={(ids) => {
              changeXrefValue('ReportIds', ids)
            }}
            disabled={disableXrefSettings}
          />

          <div className="button-wrapper">
            {loadingXref && (
              <div className="loading-type">
                <Spinner size="small" themeColor="dark-neutral" />
              </div>
            )}
            <ContextButton
              variant="danger"
              disabled={!isDirty}
              leftIcon={
                <div className="checkmark-wrapper left">
                  <Revert />
                </div>
              }
              onClick={clickRevert}
            >
              Revert
            </ContextButton>
            <ContextButton
              variant="primary"
              disabled={!isDirty}
              rightIcon={
                <div className="checkmark-wrapper right">
                  <RightArrow />
                </div>
              }
              onClick={clickSave}
            >
              Save
            </ContextButton>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UCCFilingToRecordTypeXref

//dto stuff
//     public int UCCFilingTypeId { get; set; }
//     public int UCCRecordTypeId { get; set; }
//     public int? FormDefinitionId { get; set; }
//     public List<int>? ReportIds { get; set; }
//     public int? ImageDataTypeId { get; set; }
//     public int? RequiredRecordOwnerTypeId { get; set; }
//     public int? NewRecordOwnerTypeId { get; set; }
//     public int? UCCLapseTypeId { get; set; }
//     public int? InitialLapseLength { get; set; }
//     public int? ContinuationLapseLength { get; set; }
const defaultDto = {
  UCCFilingTypeId: 0, //done
  UCCRecordTypeId: 0, //done
  FormDefinitionId: null, //done
  IncludeImageForPaperFiling: false,
  ReportIds: [], // done
  ImagePageTypeId: null, //done
  NewUCCStatusTypeId: null,
  RequiredUCCStatusTypeIds: [],
  PermittedRecordAccessUserRoleIds: [],
  NewRecordAccessUserRoleId: null
  // UCCLapseTypeId: null,
  // InitialLapseLength: null, //done
  // ContinuationLapseLength: null, //done
}
